import React from "react";
import Label from "./Label";

/**
 * In the case where this Syllabus has teaching assignments,
 * and multiple instructors are assigned to the same class section,
 * each instructor should have their own InstructorInfo element in the DOM.
 **/
const InstructorInfo = (props) => {
  return (
    <div>
      <div className="d-flex flex-row justify-content-left">
        <Label text={"Dr. " + (props.user ? props.user.full_name : "xxx")} />
      </div>
      <div className="d-flex flex-row justify-content-left">
        <Label text={"Email: " + (props.user ? props.user.email : "xxx")} />
      </div>
      <div className="d-flex flex-row justify-content-left">
        <Label
          text={
            "Office Location: " + (props.user ? props.user.office_location : "")
          }
        />
      </div>
      <div className="d-flex flex-row justify-content-left">
        <Label
          text={"Office Hours: " + (props.user ? props.user.office_hours : "")}
        />
      </div>
    </div>
  );
};

export default InstructorInfo;
